export enum eTipoPesquisaFiltroFuncionarios {
  Pedagogo = 'Pedagogo',
  ProfessorAtivo = 'ProfessorAtivo',
  ProfessorCadastrado = 'ProfessorCadastrado',
  ProfessorMagisterio = 'ProfessorMagisterio',
  ProfessorAdministrativo = 'ProfessorAdministrativo',
  TodosFuncionarios = 'TodosFuncionarios',
}

export class ModalFiltroFuncionariosParams {
  eTipoPesquisaFiltroFuncionarios: eTipoPesquisaFiltroFuncionarios =
    eTipoPesquisaFiltroFuncionarios.ProfessorCadastrado;
  route: string = '';
}
